import { JetView } from 'webix-jet'; // Importing JetView from webix-jet
import { devConfig } from '../../../config/config'; // Importing development configuration

/**
 * Class representing the payment prize view.
 * @extends JetView
 */
export default class PagoPremioView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Screen size configuration
        const left = {
            margin: 5,
            rows: [
                {
                    view: 'text',
                    name: 'Id', // Field for Client ID
                    label: _('Nro. de Cliente:'), // Localized label
                    labelPosition: 'top',
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Name', // Field for Client Name
                    label: _('Nombre del Cliente:'), // Localized label
                    labelPosition: 'top',
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Country', // Field for Country
                    label: _('Pais:'), // Localized label
                    labelPosition: 'top',
                    disabled: true, // Field is disabled
                },
                {
                    view: 'text',
                    name: 'Currency', // Field for Currency
                    label: _('Moneda:'), // Localized label
                    labelPosition: 'top',
                    disabled: true, // Field is disabled
                },
            ],
        };
        const upper_section = {
            cols: [
                { id: 'grav', gravity: 1 }, // Placeholder for layout
                left, // Left section with client details
                { id: 'grav1', gravity: 1 }, // Placeholder for layout
            ],
        };
        const buttons = {
            margin: 10,
            cols: [
                { id: 'grav2', gravity: 1 }, // Placeholder for layout
                {
                    view: 'button',
                    value: _('Activar'), // Localized button label
                    type: 'form',
                    width: screen == 'small' ? 0 : 100, // Conditional width based on screen size
                    minWidth: 200,
                    click: () => {
                        // Button click event handler
                        var vvthis = this; // Reference to the current instance
                        webix.confirm({
                            type: 'confirm-warning',
                            text: _('Advertencia!') + '<br/>' + _('Desea Activar Registro?'), // Confirmation message
                            ok: _('Activar'), // Confirm button label
                            cancel: _('Salir'), // Cancel button label
                            callback: function (action) {
                                // Callback for confirmation
                                if (action === true) {
                                    // If confirmed
                                    if (vvthis.getRoot().validate()) {
                                        // Validate form
                                        const vthis = this; // Reference to the confirmation dialog
                                        var item = vvthis.getRoot().getValues(); // Get form values
                                        webix
                                            .ajax() // AJAX request to activate registration
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Client/ActivateRegistration', // API endpoint
                                                '{ "Id":' + item.Id + ',"Action":"Activate"}', // Request body
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        // Error handler
                                                        webix.message(
                                                            'Error! ', // Error message
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        // Success handler
                                                        var dat = JSON.parse(text); // Parse response
                                                        if (dat.HasError) {
                                                            // Check for errors
                                                            webix.message({
                                                                title: '¡Error!',
                                                                type: 'alert-error',
                                                                text: _(
                                                                    'Ocurrio un error...', // Error message
                                                                ),
                                                            });
                                                        } else {
                                                            webix.message(
                                                                'Registro Activado Satisfactoriamente', // Success message
                                                            );
                                                            $$('FilterActivateRegistration').show(); // Show filter
                                                            $$('FilterActivateRegistration').clear(); // Clear filter
                                                            $$('formActivateRegistration').hide(); // Hide form
                                                            $$('back-button').hide(); // Hide back button
                                                            vvthis.getRoot().clear(); // Clear form
                                                        }
                                                    },
                                                },
                                            );
                                    }
                                }
                            },
                        });
                    },
                },
                { id: 'grav3', gravity: 1 }, // Placeholder for layout
            ],
        };
        return {
            view: 'form',
            id: 'formActivateRegistration', // Form ID
            rows: [upper_section, buttons], // Form layout
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} form - The form instance.
     */
    init(form) {
        $$('formActivateRegistration').hide(); // Initially hide the form
        webix.ready(function () {
            if (screen.width < 500) {
                // Responsive behavior for small screens
                $$('grav').hide(); // Hide layout placeholders
                $$('grav1').hide();
                $$('grav2').hide();
                $$('grav3').hide();
            }
        });
        this.on(this.app, 'activateRegistration:data', (data) => {
            // Event listener for data
            form.setValues(data); // Set form values from event data
        });
    }
}

// FILE DOCUMENTED
